import { HttpHandler, HttpProgressEvent, HttpInterceptor, HttpSentEvent, HttpHeaderResponse, HttpUserEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// needed for IE11 - IE11 caches GET-requests, so we need to make sure that this does not happen
// otherwise we would potentially receive an outdated state via GET requests after we posted an update
// see also: https://stackoverflow.com/a/49011436/1384848
@Injectable()
export class CacheHeadersInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        const nextReq = req.clone({
            headers: req.headers
                .set('Cache-Control', 'no-cache, no-store')
                .set('Pragma', 'no-cache, no-store')
                .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
                .set('If-Modified-Since', '0')
        });

        return next.handle(nextReq);
    }
}
